/**
 * Environment Configuration Resolver
 *
 * Build Once Deploy Many (BODM) strategy:
 *   1. First checks window.__ENV_CONFIG__ (runtime config from env-config.js).
 *      This is populated by Azure Pipelines with environment-specific values.
 *   2. Falls back to the static Vite-mode-based import map for local dev
 *      (npm run dev:qa, dev:int, etc.).
 *
 * See ./environments/ for per-environment endpoint definitions.
 * See ./runtime-environment.ts for the runtime config reader.
 */

import { environment as localEnvironment } from "./environments/environment.local";
import type { EnvironmentConfig } from "./environments/environment.types";
import { getRuntimeEnvironment } from "./runtime-environment";

export type { EnvironmentConfig };

/**
 * Resolved environment config:
 * - Deployed builds: reads from window.__ENV_CONFIG__ (env-config.js)
 * - Local dev: reads from static import map based on Vite mode
 */
export const environment: EnvironmentConfig =
  getRuntimeEnvironment() ?? localEnvironment;
